import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5445_18774)">
      <path
        d="M12.4999 7.71095C14.8668 7.71095 16.7857 9.63141 16.7857 12C16.7857 14.3687 14.8668 16.2892 12.4999 16.2892C10.1332 16.2892 8.21428 14.3687 8.21428 12C8.21428 9.63141 10.1332 7.71095 12.4999 7.71095ZM12.4999 -0.00939941C10.8832 -0.00939941 9.31142 0.309069 7.82643 0.93742C6.39607 1.54218 5.11357 2.4075 4.01429 3.50765C2.91499 4.6078 2.05035 5.8913 1.44607 7.32279C0.818214 8.80793 0.5 10.382 0.5 12C0.5 13.6181 0.818214 15.1911 1.44607 16.6773C2.05035 18.1087 2.91499 19.3923 4.01429 20.4924C5.11357 21.5926 6.39607 22.4579 7.82643 23.0626C9.31035 23.691 10.8832 24.0094 12.4999 24.0094C14.1167 24.0094 15.6886 23.691 17.1735 23.0626C18.6039 22.4579 19.8864 21.5926 20.9857 20.4924C22.085 19.3923 22.9497 18.1087 23.5539 16.6773C24.1818 15.1922 24.5 13.6181 24.5 12C24.5 10.382 24.1818 8.80894 23.5539 7.32279C22.9497 5.8913 22.085 4.6078 20.9857 3.50765C19.8864 2.4075 18.6039 1.54218 17.1735 0.93742C15.6897 0.309069 14.1167 -0.00939941 12.4999 -0.00939941Z"
        fill="#EAEAEA"
      />
      <path
        d="M12.5001 7.71098C14.8669 7.71098 16.7858 9.63144 16.7858 12.0001C16.7858 14.3687 14.8669 16.2892 12.5001 16.2892C10.1333 16.2892 8.21439 14.3687 8.21439 12.0001C8.21439 9.63144 10.1333 7.71098 12.5001 7.71098ZM12.5001 2.56409C7.30152 2.56409 3.07153 6.79741 3.07153 12.0001C3.07153 17.2027 7.30152 21.436 12.5001 21.436C17.6986 21.436 21.9287 17.2027 21.9287 12.0001C21.9287 6.79741 17.6986 2.56409 12.5001 2.56409Z"
        fill="#CCCCCC"
      />
      <path
        d="M12.4999 7.71101C14.8667 7.71101 16.7857 9.63144 16.7857 12.0001C16.7857 14.3687 14.8667 16.2892 12.4999 16.2892C10.1332 16.2892 8.21425 14.3687 8.21425 12.0001C8.21425 9.63144 10.1332 7.71101 12.4999 7.71101ZM12.4999 5.13757C8.71889 5.13757 5.64282 8.21605 5.64282 12.0001C5.64282 15.7842 8.71889 18.8626 12.4999 18.8626C16.2811 18.8626 19.3571 15.7842 19.3571 12.0001C19.3571 8.21605 16.2811 5.13757 12.4999 5.13757Z"
        fill="#999999"
      />
      <path
        d="M12.5 7.71094C14.8669 7.71094 16.7858 9.63135 16.7858 12C16.7858 14.3687 14.8669 16.2891 12.5 16.2891C10.1333 16.2891 8.21436 14.3687 8.21436 12C8.21436 9.63135 10.1333 7.71094 12.5 7.71094Z"
        fill="#EAEAEA"
      />
    </g>
    <defs>
      <clipPath id="clip0_5445_18774">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)
